module.exports = __webpack_public_path__ + "img/phonechat.15680cc1.svg";